import { Schema, arrayOf } from 'normalizr';

export const zone = new Schema('zones');
export const arrayOfZones = arrayOf(zone);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/api/schema.js